<template>
  <div class="securityUsers">
    <v-row>
      <v-col cols="12" sm="6">
        <div class="titleArea">
          <h2>Lumora Users</h2>
          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons"
            @click.stop="onAddNewUser"
            class="mb-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new user
          </v-btn>
        </div>
        <v-card class="pa-2" outlined tile>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="userList"
            :items-per-page="-1"
            item-key="UserId"
            @click:row="selectRow"
            dense
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6">
        <div>
          <v-form v-if="isUserSelected" v-model="isFormValid" ref="form" lazy-validation>
            <!--<FormPanel :formElements="tabElements" :readOnly="!isEditMode"></FormPanel>-->
            <v-text-field
              type="number"
              label="User Id"
              v-model="currentUser.UserId"
              disabled
            ></v-text-field>
            <v-text-field
              label="Username"
              v-model="currentUser.UserName"
            ></v-text-field>
            <v-text-field
              label="Full Name"
              v-model="currentUser.FullName"
            ></v-text-field>
            <v-text-field
              label="Email"
              v-model="currentUser.EMail"
            ></v-text-field>
            <v-text-field
              label="Telephone"
              v-model="currentUser.Telephone"
            ></v-text-field>
            <v-checkbox
              label="Active"
              v-model="currentUser.Active"
            ></v-checkbox>
            <DatePicker
              v-if="!showPasswordField"
              label="Last Login Date"
              v-model="currentUser.LastLoginDate"
            ></DatePicker>
            <DatePicker
              v-if="!showPasswordField"
              label="Last Password Change Date"
              v-model="currentUser.LastPasswordChange"
            ></DatePicker>
            <v-text-field
              v-if="!showPasswordField"
              type="number"
              label="Failed Login Attempts"
              v-model="currentUser.FailedAttempts"
            ></v-text-field>
            <v-text-field
              v-if="showPasswordField"
              label="Password"
              type="password"
              v-model="currentUser.Password"
            ></v-text-field>
          </v-form>

          <v-alert v-else type="info" outlined dense> Please, select a user </v-alert>

          <div v-if="showFormButtons && isUserSelected" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && isUserSelected"
                outlined
                color="error"
                @click="onButtonClicked('delete')"
              >
                Delete
              </v-btn>
              <v-btn
                v-if="!passwordReset && isEditMode && !isUserNew"
                outlined
                color="error"
                @click="resetPasswordClick"
              >
                Reset Password
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="!isEditMode"
                outlined
                color="primary"
                class="ml-4"
                @click="onButtonClicked('edit')"
              >
                Edit
              </v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onButtonClicked('cancel')">
                Cancel
              </v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="onButtonClicked('save')"
                class="ml-4"
                :disabled="!isFormValid"
              >
                Save
              </v-btn>
            </div>
          </div>
        </div>
        <v-dialog v-model="passwordReset" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Reset Password</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="newPassword"
                label="New Password"
                type="password"
                dense
              ></v-text-field>
              <v-text-field
                v-model="confirmPassword"
                label="Confirm Password"
                type="password"
                dense
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="passwordReset = false" color="primary" outlined>Cancel</v-btn>
              <v-btn @click="savePassword" color="primary" depressed>Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <Dialog ref="messageBox" :message="message" :title="title" v-model="dialog"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
//import FormPanel from '@/components/FormPanel.vue';
import Utils from '@/utils.js';
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  name: 'Users',
  components: {
    //FormPanel,
    Dialog,
    DatePicker,
  },
  data() {
    return {
      message: 'Are you sure you wish to delete this record ?',
      title: 'Confirmation',
      tabElements: [],
      formElements: [],
      isEditMode: false,
      dialog: false,
      userList: [],
      userId: 0,
      passwordReset: false,
      currentUser: {},
      newPassword: '',
      confirmPassword: '',
      headers: [
        { text: 'User Name', value: 'UserName' },
        { text: 'Full Name', value: 'FullName' },
      ],
      selected: [],
      isFormValid: false,
    };
  },

  computed: {
    userListLength() {
      return this.userList.length;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    isUserSelected() {
      return !!Object.keys(this.currentUser).length;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    isUserNew() {
      return this.currentUser.UserId === 0;
    },
    showPasswordField(){
      if (this.isUserSelected && this.currentUser.UserId == 0){
        return true;
      } else {
        return false
      }
    }
  },

  watch: {
    userListLength(newVal, oldVal) {
      if (oldVal === 0 && newVal > 0) {
        this.selected = [this.userList[0]];
      }
    },
    isUserNew(value){
      this.tabElements = this.formElements.filter(
        (f) => f.ParentId === 'FormFields' && f.ChildPanel === ''
      );
      if (!value){
        this.tabElements = this.tabElements.filter(
          (f) => f.FieldName !== 'Password'
        );
      } 
    },

    passwordReset(value){
      if (!value){
        this.newPassword = '';
        this.confirmPassword = '';
      }
    },
  },

  methods: {
    onAddNewUser() {
      this.clearData();
      this.selected = [];
      this.isEditMode = true;
      this.currentUser = {
        CurrentPlan: this.currentPlanId,
        UserId: 0,
        UserName: '',
        FullName: '',
        EMail: '',
        Telephone: '',
        LastLoginDate: '',
        LastLoginDateStr: '',
        LastPasswordChange: '',
        LastPasswordChangeStr: '',
        Password: '',
        Active: true,
        FailedAttempts: 0,
        TFA: '',
        SecretKey: '',
      };
    },

    async savePassword() {
      try {
        var data = {
          UserId: this.currentUser.UserId,
          NewPassword: this.newPassword,
          confirmPassword: this.confirmPassword,
        };
        await this.$api.post('/user/AdminChangeUserPassword', data);

        this.passwordReset = false;
        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Password is saved',
        });
      } catch (err) {
        console.error(err);
      }
    },
    resetPasswordClick() {
      this.passwordReset = true;
    },
    async selectRow(item) {
      this.selected = [item];
      await this.getUser(item.UserName);
    },

    async getUser(userName) {
      try {
        let response = await this.$api.get('/User/getUser', { params: { userName: userName } });

        if (!response.data) {
          const msg = 'Unable to load user ' + userName;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.currentUser = response.data;
        if (this.currentUser) Utils.setDataToFormElements(this.currentUser, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },
    async getUserList() {
      try {
        let response = await this.$api.get('/user/getuserlist');
        var data = response.data;
        this.userList = data;
      } catch (err) {
        console.error(err);
      }
    },
    async updateUser() {
      try {
        /*Object.keys(this.currentUser).forEach((e) => {
          var key = e;
          let item = this.formElements.find((o) => o.FieldName === key);
          if (item != null) {
            this.currentUser[e] = item.Value;
          }
        });*/
        await this.$api.post('/user/AdminUpdateUser', this.currentUser);

        this.getUserList();
        await this.getUser(this.currentUser.UserName);
        this.selected = [this.currentUser];
      } catch (err) {
        console.error(err);
      } finally {
        this.isEditMode = false;
      }
    },
    async deleteUser() {
      await this.$refs.messageBox.open(
        'Confirmation',
        'Are you sure you wish to delete this record ?'
      );

      try {
        await this.$api.delete('/user/deleteUser?userid=' + this.currentUser.UserId);

        this.$store.commit('setNotificationMessage', { type: 'success', text: 'User is deleted' });
        this.selected = [];
        this.currentUser = {};
        this.getUserList();
      } catch (err) {
        console.error(err);
      }
    },
    clearData() {
      this.formElements.forEach(function (e) {
        e.Value = '';
      });
    },
    async getUserForm() {
      try {
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=Users&planId=0'
        );
        if (response.data.length) {
          var elements = response.data.filter((f) => f.Visible == true);
          this.formElements = elements;
          this.tabElements = elements.filter(
            (f) => f.ParentId === 'FormFields' && f.ChildPanel === '' && f.FieldName !== 'Password'
          );
        }
        this.getUserList();
      } catch (err) {
        console.error(err);
      }
    },
    onButtonClicked(value) {
      if (value == 'cancel') {
        // reload data
        if (this.currentUser.UserId == 0) {
          if (this.userList.length > 0) {
            this.currentUser = this.userList[0];
            this.selected  = [this.currentUser];
          } else {
            this.clearData();
            return;
          }
        }
        this.getUser(this.currentUser.UserName);
        this.isEditMode = false;
      } else if (value == 'add') {
        // clear data
        this.isEditMode = true;
        this.currentUser.UserId = 0;
        this.clearData();
      } else if (value == 'save') {
        this.isFormValid = this.$refs.form.validate();
        if (this.isFormValid) this.updateUser();
      } else if (value == 'edit') {
        this.isEditMode = true;
      } else if (value == 'delete') {
        this.deleteUser();
      }
    },
  },

  mounted: function () {
    this.getUserForm();
  },
};
</script>
<style lang="scss">
.securityUsers {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;

  .formFooter {
    bottom: 0;
    width: 100%;
    margin-top: 5px;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
    }
  }

  .titleArea {
    display: flex;
    justify-content: space-between;
  }
}
</style>
